import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiUsers,
  FiBookOpen,
  FiSettings,
  FiBarChart2,
  FiUserPlus,
  FiShield,
  FiClock,
  FiFileText
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import logger from '../../utils/logging/logger';

export default function useAdminDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalCourses: 0,
    totalInstructors: 0,
    totalStudents: 0,
    activeSessions: 0,
    pendingApprovals: 0
  });

  useEffect(() => {
    fetchAdminStats();
  }, []);

  const fetchAdminStats = async () => {
    try {
      // You can add API calls here to fetch admin-specific statistics
      // For now, using mock data
      setStats({
        totalUsers: 156,
        totalCourses: 12,
        totalInstructors: 8,
        totalStudents: 148,
        activeSessions: 3,
        pendingApprovals: 2
      });
    } catch (error) {
      logger.error('Error fetching admin stats', { error });
    }
  };

  const quickActions = [
    {
      title: 'User Management',
      description: 'Manage users, roles, and permissions',
      icon: <FiUsers size={24} />,
      color: 'primary',
      onClick: () => navigate('/admin/users')
    },
    {
      title: 'Course Management',
      description: 'Create and manage courses',
      icon: <FiBookOpen size={24} />,
      color: 'success',
      onClick: () => navigate('/admin/courses')
    },
    {
      title: 'Attendance Management',
      description: 'Monitor and manage attendance',
      icon: <FiClock size={24} />,
      color: 'info',
      onClick: () => navigate('/admin/attendance')
    },
    {
      title: 'System Settings',
      description: 'Configure system preferences',
      icon: <FiSettings size={24} />,
      color: 'warning',
      onClick: () => navigate('/admin/settings')
    },
    {
      title: 'Analytics & Reports',
      description: 'View system analytics and reports',
      icon: <FiBarChart2 size={24} />,
      color: 'info',
      onClick: () => navigate('/admin/analytics')
    },
    {
      title: 'Content Management',
      description: 'Manage course content and materials',
      icon: <FiFileText size={24} />,
      color: 'success',
      onClick: () => navigate('/admin/content')
    }
  ];

  const recentActivities = [
    {
      id: 1,
      title: 'New student registration: Ahmed Al-Rashid',
      time: '2 hours ago',
      type: 'user'
    },
    {
      id: 2,
      title: 'Course "Advanced Arabic Grammar" created',
      time: '4 hours ago',
      type: 'course'
    },
    {
      id: 3,
      title: 'Attendance session started for Islamic Studies',
      time: '6 hours ago',
      type: 'attendance'
    },
    {
      id: 4,
      title: 'System backup completed successfully',
      time: '1 day ago',
      type: 'system'
    }
  ];

  const getActivityIcon = (type) => {
    switch (type) {
      case 'user':
        return <FiUserPlus size={16} />;
      case 'course':
        return <FiBookOpen size={16} />;
      case 'attendance':
        return <FiClock size={16} />;
      case 'system':
        return <FiShield size={16} />;
      default:
        return <FiSettings size={16} />;
    }
  };

  return {
    user,
    stats,
    quickActions,
    recentActivities,
    getActivityIcon
  };
}
